"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Org Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrgServiceClient = void 0;
__exportStar(require("./api"), exports);
__exportStar(require("./configuration"), exports);
const axios_1 = __importDefault(require("axios"));
const agentkeepalive_1 = __importDefault(require("agentkeepalive"));
const configuration_1 = require("./configuration");
const OrgService = __importStar(require("./api"));
const agentKeepaliveDefaultOptions = {
    keepAlive: true,
    maxSockets: 124,
    maxFreeSockets: 10,
    freeSocketTimeout: 30000,
    timeout: 60000,
};
function createOrgServiceClient({ axios = axios_1.default.create(), secret, superSecret, remoteAppCode = 'auto', httpAgent = true, httpsAgent, ...configurationProps }) {
    axios.interceptors.request.use((config) => {
        var _a, _b;
        if (config.sessionId != null) {
            config.headers.set('x-session-id', config.sessionId);
            config.headers.set('everhelper-session-id', config.sessionId);
        }
        if (config.userId != null) {
            const requestRemoteAppCode = (_a = config.remoteAppCode) !== null && _a !== void 0 ? _a : remoteAppCode;
            config.headers.set('Authorization', `Internal ${config.userId}:${requestRemoteAppCode}`);
            const requestSecret = (_b = config.secret) !== null && _b !== void 0 ? _b : secret;
            if (requestSecret == null) {
                throw new Error('secret is not provided');
            }
            config.headers.set('X-Secret', requestSecret);
        }
        if (config.secret != null) {
            config.headers.set('X-Secret', config.secret);
        }
        if (config.superUser === true) {
            if (superSecret == null) {
                throw new Error('superSecret is not provided');
            }
            config.headers.set('X-Secret', superSecret);
        }
        return config;
    });
    if (httpAgent instanceof agentkeepalive_1.default) {
        axios.defaults.httpAgent = httpAgent;
    }
    else if (typeof httpAgent === 'object') {
        axios.defaults.httpAgent = new agentkeepalive_1.default({
            ...agentKeepaliveDefaultOptions,
            ...httpAgent,
        });
    }
    else if (httpAgent === true) {
        axios.defaults.httpAgent = new agentkeepalive_1.default(agentKeepaliveDefaultOptions);
    }
    if (httpsAgent instanceof agentkeepalive_1.default.HttpsAgent) {
        axios.defaults.httpsAgent = httpsAgent;
    }
    else if (typeof httpsAgent === 'object') {
        axios.defaults.httpsAgent = new agentkeepalive_1.default({
            ...agentKeepaliveDefaultOptions,
            ...httpsAgent,
        });
    }
    else if (httpsAgent === true) {
        axios.defaults.httpsAgent = new agentkeepalive_1.default.HttpsAgent(agentKeepaliveDefaultOptions);
    }
    const configuration = new configuration_1.Configuration(configurationProps);
    return {
        AddonApi: OrgService.AddonApiFactory(configuration, configuration.basePath, axios),
        BillingInfoApi: OrgService.BillingInfoApiFactory(configuration, configuration.basePath, axios),
        CouponApi: OrgService.CouponApiFactory(configuration, configuration.basePath, axios),
        CouponsApi: OrgService.CouponsApiFactory(configuration, configuration.basePath, axios),
        DomainApi: OrgService.DomainApiFactory(configuration, configuration.basePath, axios),
        FeaturesApi: OrgService.FeaturesApiFactory(configuration, configuration.basePath, axios),
        InternalApi: OrgService.InternalApiFactory(configuration, configuration.basePath, axios),
        InvitesApi: OrgService.InvitesApiFactory(configuration, configuration.basePath, axios),
        MemberApi: OrgService.MemberApiFactory(configuration, configuration.basePath, axios),
        MembersApi: OrgService.MembersApiFactory(configuration, configuration.basePath, axios),
        OrgAutoDomainsApi: OrgService.OrgAutoDomainsApiFactory(configuration, configuration.basePath, axios),
        OrgsApi: OrgService.OrgsApiFactory(configuration, configuration.basePath, axios),
        PlansApi: OrgService.PlansApiFactory(configuration, configuration.basePath, axios),
        TagApi: OrgService.TagApiFactory(configuration, configuration.basePath, axios),
        UsageApi: OrgService.UsageApiFactory(configuration, configuration.basePath, axios),
        UserRoleApi: OrgService.UserRoleApiFactory(configuration, configuration.basePath, axios),
    };
}
exports.createOrgServiceClient = createOrgServiceClient;
//# sourceMappingURL=index.js.map